ixModuleRouting('impactx.productgroup', {
    '/editproductgroups/:catId': {
        template: '<ixa-product-groups-edit></ixa-product-groups-edit>',
        templateUrl: 'modules/productgroup/templates/editproductgroups.html',
        controller: 'ProductGroupsEditCtrl',
        controllerAs: 'productGroupsEditCtrl',
        process: 'EditCatalog',
        workspace: 'content'
    },
    '/editvcatproductgroups/:vcatId': {
        template: '<ixa-product-groups-edit></ixa-product-groups-edit>',
        templateUrl: 'modules/productgroup/templates/editproductgroups.html',
        controller: 'ProductGroupsEditCtrl',
        controllerAs: 'productGroupsEditCtrl',
        process: 'VCatalog',
        workspace: 'content'
    },
    '/viewextensionprgprice': {
        templateUrl: 'modules/productgroup/templates/viewextension-edit-prg-price.tmpl.html',
        controller: 'ViewExtensionEditPRGController',
        controllerAs: '$ctrl',
        process: 'ProductChange',
        workspace: 'content'
    }
});